import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useWaldoEvent } from '@byscott-io/where-is-waldo'
import { Store as notificationStore } from 'react-notifications-component'

// Global realtime toast notifications (#629), ported from GlobalPusherService onto
// whereiswaldo. Mirrors the old behaviour: show a toast for an activity event ONLY
// when the user is NOT on the dashboard (where the activity feed already shows it);
// clicking the toast navigates to the relevant page. The ActivityFeedPanel subscribes
// to the same events itself to refresh the feed.
const TOASTS = {
  journal_entry_created: () => ({ title: '📝 New Journal Entry', message: 'A team member logged progress', type: 'info', path: '' }),
  task_created: (d) => ({ title: '📋 New Task Created', message: `Task: ${d.content || 'Untitled'}`, type: 'info', path: '/goals' }),
  task_completed: (d) => ({ title: '✅ Task Completed', message: `Completed: ${d.content || 'Untitled'}`, type: 'success', path: '/goals' }),
  goal_created: (d) => ({ title: '🎯 New Goal Created', message: `Goal: ${d.name || 'Untitled'}`, type: 'info', path: '/goals' }),
  strategy_created: (d) => ({ title: '♟️ New Strategy Created', message: `Strategy: ${d.name || 'Untitled'}`, type: 'info', path: '/strategies' }),
}

const EVENT_TYPES = Object.keys(TOASTS)

const RealtimeActivity = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const accountId = (location.pathname.match(/\/app\/(\d+)/) || [])[1]
  const onDashboard = Boolean(accountId) &&
    (location.pathname === `/app/${accountId}` || location.pathname === `/app/${accountId}/`)

  const notify = useCallback((type, data = {}) => {
    const build = TOASTS[type]
    // On the dashboard the activity feed already surfaces this — skip the toast.
    if (!build || onDashboard) return

    const { title, message, type: kind, path } = build(data)
    notificationStore.addNotification({
      title,
      message,
      type: kind,
      insert: 'bottom',
      container: 'bottom-left',
      animationIn: ['animate__animated', 'animate__fadeIn'],
      animationOut: ['animate__animated', 'animate__fadeOut'],
      dismiss: { duration: 30000, onScreen: true, pauseOnHover: true, showIcon: true },
      onRemoval: (id, removedBy) => {
        if (removedBy === 'click' && accountId) navigate(`/app/${accountId}${path}`)
      },
    })
  }, [onDashboard, accountId, navigate])

  useWaldoEvent(EVENT_TYPES, (data, message) => notify(message?.type, data))

  return null
}

export default RealtimeActivity
